import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { AdminModulo, ModuloAdminCreate, ModuloAdminUpdate } from "@/types/api";

export function useAdminModuli() {
  return useQuery({
    queryKey: ["admin-moduli"],
    queryFn: () => apiFetch<AdminModulo[]>("/api/v1/admin/moduli"),
    staleTime: 30_000,
  });
}

interface ModificaArgs {
  codice: string;
  body: ModuloAdminUpdate;
}

export function useModificaModulo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ codice, body }: ModificaArgs) =>
      apiFetch<AdminModulo>(
        `/api/v1/admin/moduli/${encodeURIComponent(codice)}`,
        {
          method: "PATCH",
          body: JSON.stringify(body),
        }
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["admin-moduli"] });
      qc.invalidateQueries({ queryKey: ["moduli"] });
      qc.invalidateQueries({ queryKey: ["avanzamento"] });
    },
  });
}

/**
 * Crea un modulo **di vetrina** (Enrico, 21-08-2026: «solo vetrina, perché li
 * dovremo contrattualizzare»). Non crea permesso né rotta.
 *
 * Invalida anche l'avanzamento: un modulo funzionale in più cambia la media che
 * il cliente legge in prima pagina.
 */
export function useCreaModulo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ModuloAdminCreate) =>
      apiFetch<AdminModulo>("/api/v1/admin/moduli", {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["admin-moduli"] });
      qc.invalidateQueries({ queryKey: ["moduli"] });
      qc.invalidateQueries({ queryKey: ["avanzamento"] });
    },
  });
}
